import React from 'react';
import { Grid, TextField, Autocomplete, Typography, Box, Button, Tooltip } from '@mui/material';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { operationProcedureOptions, diagnoses } from '../constants/options';
import { SURGERY_TEMPLATES } from '../../../../utils/formSync';

const BasicInfoSection = ({ formData, handleChange, handleNameChange, handleBlur, setFormData, applyTemplate, errors }) => {
  return (
    <Box>
      <Box sx={{ mb: 3, p: 2, border: '1px solid #9cededff', borderRadius: 2, bgcolor: '#f0fdf4'}}>
        <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1, color: '#166534', display: 'flex', alignItems: 'center', gap: 1 }}>
          <AutoFixHighIcon fontSize="small" /> QUICK TEMPLATES — Click to auto-fill risks & care plan:
        </Typography>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
          {Object.keys(SURGERY_TEMPLATES).map((surgery) => (
            <Tooltip key={surgery} title={`Apply template for ${surgery}`}>
              <Button
                size="small"
                variant="outlined"
                color="success"
                onClick={() => applyTemplate(surgery)}
                sx={{ textTransform: 'none', borderRadius: 3, fontSize: '0.75rem' }}
              >
                {surgery}
              </Button>
            </Tooltip>
          ))}
        </Box>
      </Box>

      <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
        It is the policy of <b>ANNAI ARUL HOSPITAL (P) LTD</b> to inform the patient of the proposed Medical/Surgical Procedure, and you are free to ask your doctors any questions regarding the same.
      </Typography>

      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 1: Patient & Procedure Info
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="IP No."
            name="ip_no"
            value={formData.ip_no || ''}
            fullWidth
            InputProps={{ readOnly: true }}
            helperText="Auto-generated IP number"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="UHID No."
            name="uhid_no"
            value={formData.uhid_no || ''}
            fullWidth
            InputProps={{ readOnly: true }}
            helperText="Unique Hospital ID"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label={<span>Patient Name <span style={{ color: 'red' }}>*</span></span>}
            name="patient_name"
            value={formData.patient_name || ''}
            onChange={handleNameChange}
            onBlur={handleBlur}
            fullWidth
            error={!!errors.patient_name}
            helperText={errors.patient_name}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
            1. I hereby give consent to the following Operation(s) / Procedure(s) (hereafter referred to as procedure(s)):
          </Typography>
          <Autocomplete
            freeSolo
            options={operationProcedureOptions}
            value={formData.operation_procedure || ''}
            onChange={(e, val) => {
              setFormData(prev => ({ ...prev, operation_procedure: val }));
              if (val && SURGERY_TEMPLATES[val]) applyTemplate(val);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={<span>Operation / Procedure <span style={{ color: 'red' }}>*</span></span>}
                name="operation_procedure"
                onBlur={handleBlur}
                error={!!errors.operation_procedure}
                helperText={errors.operation_procedure || "Enter the operation procedure"}
                onChange={handleChange}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            freeSolo
            options={diagnoses}
            value={formData.diagnosis || ''}
            onChange={(e, val) => setFormData(prev => ({ ...prev, diagnosis: val }))}
            renderInput={(params) => (
              <TextField
                {...params}
                label={<span>Diagnosis <span style={{ color: 'red' }}>*</span></span>}
                name="diagnosis"
                onBlur={handleBlur}
                error={!!errors.diagnosis}
                helperText={errors.diagnosis}
                onChange={handleChange}
              />
            )}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default BasicInfoSection;
